<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
    name: 'Itabs',
  });
</script>
<script lang="ts" setup>
  defineProps({
  
});

  ;
</script>

<template>
  <div> Itabs components </div>
</template>

<style scoped></style>
